// @ts-nocheck
/*
 * Port of session-replay/components/PlaybackControls.js (89 lines). BYTE-IDENTICAL.
 * Play/pause + ±10s jumps + 1x/2x/4x speed. v1 has the Skip-Idle and
 * Heatmap buttons commented out — kept commented here too so we match v1
 * exactly and can uncomment if/when the feature is turned back on.
 */
import React from 'react';
import { Play, Pause, Rewind, FastForward } from 'lucide-react';
import { formatDuration } from '../replayUtils';

const SPEEDS = [1, 2, 4];

const btnBase =
  'inline-flex items-center justify-center gap-1.5 rounded-md border border-border/60 bg-card px-3 py-1.5 text-xs font-semibold text-foreground shadow-[3px_3px_6px_rgba(163,177,198,0.35),-3px_-3px_6px_rgba(255,255,255,0.9)] transition-colors hover:bg-accent hover:text-accent-foreground cursor-pointer';
const btnActive =
  'inline-flex items-center justify-center gap-1.5 rounded-md border border-primary bg-primary px-3 py-1.5 text-xs font-bold text-primary-foreground shadow-[3px_3px_6px_rgba(163,177,198,0.4),-3px_-3px_6px_rgba(255,255,255,0.9)] cursor-pointer';

export default function PlaybackControls({
  playing,
  speed,
  skipIdle,
  heatmapOn,
  currentMs,
  durationMs,
  onPlayPause,
  onSpeedChange,
  onSkipIdleToggle,
  onHeatmapToggle,
  onJump,
}: any) {
  return (
    <div className="flex flex-wrap items-center gap-2 py-2.5">
      <button
        type="button"
        className={btnBase}
        onClick={() => onJump?.(-10000)}
        title="Back 10s"
      >
        <Rewind className="h-3.5 w-3.5" />
        10s
      </button>
      <button
        type="button"
        className={btnActive + ' min-w-[90px]'}
        onClick={onPlayPause}
        title="Play / Pause (space)"
      >
        {playing ? (
          <>
            <Pause className="h-3.5 w-3.5" />
            Pause
          </>
        ) : (
          <>
            <Play className="h-3.5 w-3.5" />
            Play
          </>
        )}
      </button>
      <button
        type="button"
        className={btnBase}
        onClick={() => onJump?.(10000)}
        title="Forward 10s"
      >
        10s
        <FastForward className="h-3.5 w-3.5" />
      </button>

      <span aria-hidden className="mx-1 h-6 w-px bg-border/60" />

      <div className="inline-flex items-center gap-1 rounded-md border border-border/60 bg-muted/40 p-0.5">
        {SPEEDS.map((s) => (
          <button
            key={s}
            type="button"
            onClick={() => onSpeedChange?.(s)}
            className={
              'inline-flex items-center justify-center rounded px-2.5 py-1 text-xs font-semibold transition-colors cursor-pointer ' +
              (speed === s
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'text-foreground hover:bg-card')
            }
          >
            {s}x
          </button>
        ))}
      </div>

      <span
        className="ml-auto font-mono text-xs tabular-nums text-muted-foreground"
      >
        <span className="font-semibold text-foreground">
          {formatDuration(currentMs / 1000)}
        </span>{' '}
        / {formatDuration(durationMs / 1000)}
      </span>
    </div>
  );
}
